export default __webpack_public_path__ + "static/media/img-floor.47970253.png";